export default class GoodList {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  numField = "num";
  priceField = "Price";
  checkField = "";

  state = {
    list: [],
  };

  constructor({ list, checkField }) {
    this.state.list = list;
    this.checkField = checkField;
  }

  updateList(list) {
    this.state.list = list;
  }

  //改变数量
  changeNum(item, num) {
    if (this.debug) console.log("改变数量");
  }

  //计算选中的数量合计
  getSelectedLength() {
    if (this.debug) console.log("计算选中的数量合计");
    let { list } = this.state;
    let sum = 0;

    list.forEach((it) => {
      if (!this.checkField || (it[this.checkField] && it[this.checkField])) {
        sum += it[this.numField];
      }
    });

    console.log("sum", sum);

    return sum;
  }

  //计算选中的金额合计
  getSelectedAmount() {
    if (this.debug) console.log("计算选中的金额合计");
    let { list } = this.state;
    let sum = 0;

    list.forEach((it) => {
      if (!this.checkField || (it[this.checkField] && it[this.checkField])) {
        sum += it[this.numField] * it[this.priceField];
      }
    });

    return sum;
  }
}
